














































































import { ImageManagerService as imageApi } from "@/common/api";
import { AwsService as awsApi } from "@/common/api/services/AwsService";
import { formatImageUrl } from "@/common/utils";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.svg");

Dropzone.autoDiscover = false;

@Component({
  name: "qUploadSingleImageFile",
  components: {
    // Loading,
  },
})
export default class qUploadSingleImageFile extends Vue {
  @Prop({
    default: () => {
      return {
        uploadMultiple: false,
      };
    },
  })
  public options;

  @Prop({
    default: () => "300x300",
  })
  public imageSize;

  @Prop({
    default: () => "",
  })
  public initImage;

  @Prop({
    default: () => true,
  })
  public showUploadImg;

  public selfFile = null;
  public image = "";
  public errors = [];

  public dropzone;

  public fileErrors = [];

  get noImageUrl() {
    return noImage;
  }

  @Watch("initImage")
  public watchFileInput() {
    this.image = this.initImage;
  }

  public mounted() {
    this.image = this.initImage;
    const localOptions = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "PUT",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        const _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,
      maxFiles: 1,
      // Here we request a signed upload URL when a file being accepted
      accept: async (file, done) => {
        const extension = file.name.split(".").pop();
        const result = await awsApi.awsUploadPresign({
          fileName: file.upload.uuid + "." + extension,
        });
        file.uploadURL = result.data.presign.url;
        (file.filePath = file.upload.uuid + "." + extension), done();
        setTimeout(() => this.dropzone.processFile(file));
      },
    };
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, {
      ...localOptions,
      ...this.options,
    });
    // Set signed upload URL for each file
    this.dropzone.on("processing", (file) => {
      this.dropzone.options.url = file.uploadURL;
      this.$emit("uploading", true);
    });
    this.dropzone.on("success", (file) => this.addFile(file));
    this.dropzone.on("uploadprogress", (file) => {
      this.$emit("uploading", true);
      this.addFile(file);
    });
    this.dropzone.hiddenFileInput.addEventListener("cancel", () => {
      this.$emit("cancel", true);
    });
    this.dropzone.on("error", (file, message) => this.addFile(file, message));
  }

  public formatUrl(fileName) {
    return fileName ? formatImageUrl(fileName, this.imageSize) : "";
  }

  public open() {
    this.errors = [];
    this.dropzone.hiddenFileInput.click();
  }

  public async addFile(file, message = "") {
    if (file.status === "error") {
      this.selfFile = null;
      this.dropzone.removeFile(file);
      this.$emit("showError", message);
      this.$emit("uploading", false);
    }

    this.selfFile = file;
    if (file.status === "success") {
      // call api add file
      const extension = file.name.split(".").pop();
      let result: any;
      try {
        result = await imageApi.adminImageUpload({
          list: [
            {
              name: file.filePath,
              originalName: file.name,
              container: "File",
              extension,
              mimeType: file.type,
              size: file.size,
              uuid: file.upload.uuid,
            },
          ],
        });
      } catch (error) {
        result = error.body;
      }
      if (result.status === "error") {
        file.status = "error";
        file.errorMessage = result.message;
        this.errors.push(`${file.name}: ${result.message}`);
        this.removeFile(file);
      } else {
        file.id = result.data.images[0].id;
        this.image = result.data.images[0].name;
        this.$emit("changed", this.selfFile);
      }
      this.$emit("uploading", false);
    }
  }

  public removeFile(file) {
    if (file && file.upload) {
      // instance of file
      this.dropzone.removeFile(file);
    }
    this.selfFile = null;
    this.image = "";
    this.$emit("changed", this.selfFile);
  }

  public reset() {
    this.image = this.initImage;
    if (this.selfFile && this.selfFile.upload) {
      // instance of file
      this.dropzone.removeFile(this.selfFile);
    }
    this.selfFile = null;
  }
}
